import { useEffect, useState } from "react";
import { LinearProgress, Box } from "@mui/material";

const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const handler = (e) => setLoading(e.detail.active);
    window.addEventListener("api-loading", handler);
    return () => window.removeEventListener("api-loading", handler);
  }, []);

  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 9999,
      }}
    >
      <LinearProgress variant="determinate" value={progress} color="error" />
    </Box>
  );
};

export default GlobalLoader;
